import { render, staticRenderFns } from "./CMSOption.vue?vue&type=template&id=067158de"
import script from "./CMSOption.vue?vue&type=script&lang=js"
export * from "./CMSOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports